export default "__VITE_ASSET__26084bfe__"